export default function discardChoicesReducer(state = [], action) {
  const { choiceId, mockId, questionStemId } = action;
  switch (action.type) {
    case "DISCARD_CHOICE":
      return [...state, { choiceId, mockId, questionStemId }];
    case "UNDISCARD_CHOICE":
      return state.filter(
        (discardedChoice) =>
          discardedChoice.choiceId != action.choiceId ||
          discardedChoice.mockId != action.mockId ||
          discardedChoice.questionStemId != action.questionStemId
      );
    default:
      return state;
  }
}
